import React from 'react'
import Logo from '../Logo'

import Container from '../../../../components/Container'

import './index.scss'

const Logos = ({ items }) => (
  <Container>
    <div className="logos">
      {items.map(item => (
        <Logo key={item.text} text={item.text} image={item.image} imageSelected={item.imageSelected} href={item.href} height={item.height} />
      ))}
    </div>
  </Container>
)

export default Logos
